'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { SessionProvider } from 'next-auth/react'
import { NuqsAdapter } from 'nuqs/adapters/next/app'

import { BarcodeReader } from '@/components/molecules'
import { LoaderProvider } from '@/components/providers/loader-provider'
import { ModalProvider } from '@/components/providers/modal-provider'
import { RefProvider } from '@/components/providers/ref-provider'
import { StoreProvider } from '@/components/providers/store-provider'
import { Toaster, TooltipProvider } from '@/components/ui'

const queryClient = new QueryClient()

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <NuqsAdapter>
        <StoreProvider>
          <QueryClientProvider client={queryClient}>
            <RefProvider>
              <ModalProvider>
                <TooltipProvider delayDuration={10}>{children}</TooltipProvider>
              </ModalProvider>
              <Toaster
                className="hidden lg:block"
                position="top-right"
                richColors
                duration={1000}
                theme="light"
              />
              <Toaster
                className="lg:hidden"
                position="bottom-right"
                richColors
                duration={1000}
                theme="light"
              />
              <LoaderProvider />
              <BarcodeReader />
            </RefProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </StoreProvider>
      </NuqsAdapter>
    </SessionProvider>
  )
}
